export default function (element, data) {
  const playlist = data.playlist;
  let currentTrackIndex = 0;

  // Очищаем контейнер
  element.innerHTML = "";

  const iframeWrapper = document.createElement("div");
  iframeWrapper.classList.add("player-iframe-wrapper");

  // Создаем iframe для YouTube плеера
  const iframe = document.createElement("iframe");
  iframe.classList.add("player-iframe");
  iframe.setAttribute(
    "allow",
    "accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture",
  );
  iframe.setAttribute("allowfullscreen", "");

  iframeWrapper.appendChild(iframe);

  // Создаем обёртку для информации о текущем треке
  const currentTrackInfo = document.createElement("div");
  currentTrackInfo.classList.add("current-track-info");

  const currentTrackTitle = document.createElement("div");
  currentTrackTitle.classList.add("current-track-title");

  const currentTrackArtist = document.createElement("div");
  currentTrackArtist.classList.add("current-track-artist");

  currentTrackInfo.appendChild(currentTrackTitle);
  currentTrackInfo.appendChild(currentTrackArtist);

  // Создаем контейнер для списка
  const playlistContainer = document.createElement("div");
  playlistContainer.classList.add("playlist-container");

  // Слушаем сообщения от YouTube iframe
  window.addEventListener("message", function (event) {
    // Проверяем разные возможные источники
    if (
      !event.origin.includes("youtube.com") &&
      !event.origin.includes("google.com")
    )
      return;

    try {
      let data;
      if (typeof event.data === "string") {
        data = JSON.parse(event.data);
      } else {
        data = event.data;
      }

      // Разные форматы событий YouTube
      if (
        data.event === "video-event" &&
        data.info &&
        data.info.playerState === 0
      ) {
        playNextTrack();
      } else if (data.event === "onStateChange" && data.info === 0) {
        playNextTrack();
      } else if (data.info && data.info.playerState === 0) {
        playNextTrack();
      } else if (data === "ended" || data.type === "ended") {
        playNextTrack();
      }
    } catch (e) {
      // Проверяем строковые сообщения
      if (typeof event.data === "string" && event.data.includes("ended")) {
        playNextTrack();
      }
    }
  });

  // Функция переключения на следующий трек
  function playNextTrack() {
    if (currentTrackIndex < playlist.length - 1) {
      currentTrackIndex++;
      selectTrack(currentTrackIndex);
    } else {
      // Можно зациклить плейлист, раскомментировав строки ниже:
      // currentTrackIndex = 0;
      // selectTrack(currentTrackIndex);
    }
  }

  // Функция выбора трека по индексу
  function selectTrack(index) {
    currentTrackIndex = index;
    const track = playlist[index];
    loadTrack(track);
    updateActiveTrack(index);
    updateCurrentTrackInfo(track);
  }

  // Функция для обновления iframe с autoplay и enablejsapi
  function loadTrack(track) {
    const embedUrl = track.embedUrl;

    // Пробуем разные варианты параметров для активации событий
    const separator = embedUrl.includes("?") ? "&" : "?";
    const enhancedUrl =
      embedUrl +
      separator +
      "autoplay=1&enablejsapi=1&origin=" +
      encodeURIComponent(window.location.origin);

    iframe.src = enhancedUrl;

    // Альтернативный метод: периодическая проверка состояния iframe
    if (iframe.trackChecker) {
      clearInterval(iframe.trackChecker);
    }

    // Запускаем таймер для отслеживания окончания видео
    iframe.trackChecker = setInterval(() => {
      try {
        // Пробуем получить информацию о состоянии плеера через postMessage
        iframe.contentWindow.postMessage(
          '{"event":"listening","id":"' +
            Math.random() +
            '","channel":"widget"}',
          "*",
        );
      } catch (e) {
        // Игнорируем ошибки
      }
    }, 1000);
  }

  // Функция обновления информации о текущем треке
  function updateCurrentTrackInfo(track) {
    currentTrackTitle.textContent = track.title;
    currentTrackArtist.textContent = track.artist;
  }

  // Функция обновления активного трека в списке
  function updateActiveTrack(index) {
    const allTracks = playlistContainer.children;
    Array.from(allTracks).forEach((trackElement, i) => {
      if (i === index) {
        trackElement.classList.add("active");
      } else {
        trackElement.classList.remove("active");
      }
    });
  }

  // Функция для получения обложки YouTube видео
  function getYouTubeThumbnail(videoId, quality = "default") {
    // Доступные варианты качества:
    // default.jpg - 120x90
    // mqdefault.jpg - 320x180
    // hqdefault.jpg - 480x360
    // sddefault.jpg - 640x480
    // maxresdefault.jpg - 1280x720 (не всегда доступно)
    return `https://img.youtube.com/vi/${videoId}/${quality}.jpg`;
  }

  // Функция для создания элемента трека
  function createTrackElement(track, index) {
    const trackElement = document.createElement("div");
    trackElement.classList.add("track");

    // Создаем обложку
    const thumbnail = document.createElement("img");
    thumbnail.classList.add("track-thumbnail");
    thumbnail.src = getYouTubeThumbnail(track.videoId);
    thumbnail.alt = `${track.title} - ${track.artist}`;

    // Добавляем обработчик ошибки загрузки изображения
    thumbnail.onerror = function () {
      if (this.src.includes("default")) {
        this.src = getYouTubeThumbnail(track.videoId, "mqdefault");
      } else if (this.src.includes("mqdefault")) {
        this.src = getYouTubeThumbnail(track.videoId, "hqdefault");
      }
    };

    // Создаем контейнер для текстовой информации
    const trackInfo = document.createElement("div");
    trackInfo.classList.add("track-info");

    const title = document.createElement("div");
    title.classList.add("track-title");
    title.textContent = track.title;

    const artist = document.createElement("div");
    artist.classList.add("track-artist");
    artist.textContent = track.artist;

    trackInfo.appendChild(title);
    trackInfo.appendChild(artist);

    trackElement.appendChild(thumbnail);
    trackElement.appendChild(trackInfo);

    // Добавляем обработчик клика
    trackElement.addEventListener("click", () => {
      selectTrack(index);
    });

    return trackElement;
  }

  // Добавляем треки в список
  playlist.forEach((track, index) => {
    const trackElement = createTrackElement(track, index);
    playlistContainer.appendChild(trackElement);
  });

  // Собираем все элементы
  element.appendChild(iframeWrapper);
  element.appendChild(currentTrackInfo);
  element.appendChild(playlistContainer);

  // Загружаем первый трек при инициализации
  if (playlist.length > 0) {
    selectTrack(0);
  }
}
